import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useRosterInfo } from "@/hooks";
import { selectWeeklyPlanData } from "@/store/slices";
import { AsyncLoadingState } from "@/features/dashboard/enums";
import { WeeklyPlanStateData } from "@/models";
import { AssignmentStatus } from "@/enums";

export type ReferencePlanState = {data: WeeklyPlanStateData};

export const useReferencePlan = (): ReferencePlanState => {
  const { assignments, dateFrom, curTrack } = useSelector(selectWeeklyPlanData); // We get last weeks assignments from the weekly plan data
  const { students } = useRosterInfo();

  const { 
    dateStart: lastWeekDateFrom,
    dateEnd: lastWeekDateTo
  } = useMemo(() => {
    if (!dateFrom) return { dateStart: "", dateEnd: "" };
    const dateStart = new Date(dateFrom);
    const dateEnd = new Date(dateFrom);
    dateStart.setHours(0, 0, 0, 0);
    dateStart.setDate(dateStart.getDate() - 7);
    return { dateStart, dateEnd };
  }, [dateFrom]);

  const lastWeekAssignments = useMemo(() => {
    if (!assignments || !dateFrom || !lastWeekDateFrom || !lastWeekDateTo) return [];
    const refAssignments = structuredClone(assignments);
    // //  const refAssignments = structuredClone(assignments).slice(0,5);
    // refAssignments.forEach((a) => {
    //       const updatedDate = new Date(lastWeekDateFrom as Date);
    //       updatedDate.setDate(updatedDate.getDate() + 2);
    //       a.dateFrom = updatedDate.toISOString();
    //       a.status = AssignmentStatus.IN_PROGRESS;
    //     });
    //     console.log("----=====> reference plan assignments", refAssignments);

    return refAssignments.filter(({ dateFrom: assignmentDateFrom }) => {
      const assignmentDate = new Date(assignmentDateFrom);
      return assignmentDate >= lastWeekDateFrom && assignmentDate < lastWeekDateTo && assignmentDateFrom !== dateFrom;
    });
  }, [assignments, dateFrom, lastWeekDateFrom, lastWeekDateTo]);

  // We have to collect an entirely separate set of mastery data for the reference plan
  const mastery = useMemo(() => {
    if (!lastWeekAssignments || !students) return {};
    // Gather all the focus skill Ids from the last week assignments

    // Fetch mastery for all students for the focus skill Ids

/* 
    capture mastery flags for each student
      no_data → red
      red → red
      yellow → yellow
      yellow → red
      green → yellow
      green → red

    Specific exclusions:
      red → yellow
      no_data → yellow
      yellow → green
*/

    // search through mastery records for each student

    // capture flagged mastery records and track in a state

    // Return the mastery data

    return {};
  }, [ lastWeekAssignments, students ]);

  return {
    data: {
      assignments: lastWeekAssignments,
      curriculum: {
        name: "",
        dateTo: "",
        dateFrom: "",
        tracks: []
      },
      curTrack,
      dateFrom: lastWeekDateFrom instanceof Date ? lastWeekDateFrom.toISOString() : "",
      dateTo: lastWeekDateTo instanceof Date ? lastWeekDateTo.toISOString() : "",
      studentAssignmentInfo: [],
      curriculumInfo: [],
      stories: {},
      resources: [],
      resourcesFetchQueue: [],
      masteryFetchQueue: [],
      crudAssignmentQueue: [],
      crudResponseByLessonPlanId: [],
      searchedStories: [],
      fetchSkillResourcesLoading: 0,
      mutateAssignmentsLoading: AsyncLoadingState.NONE,
      // Proxied values from the weekly plan data
      students,
      mastery,
    }
  }
}